import Popup from 'reactjs-popup';

export default function Modal({open, setOpen, children}) {
    if (!open) {
        return null;
    }

    return (<>
        <Popup
            open={open}
            closeOnDocumentClick
            onClose={() => setOpen(false)}
        >
            <div className="modal">
                <div className="modal__content">
                    <div className="modal__text">
                        <div>
                            {children}
                        </div>
                    </div>
                    <div className="modal__button">
                        <button className="button" type="button" onClick={() => setOpen(false)}>OK</button>
                    </div>
                </div>
            </div>
        </Popup>
    </>);
}
